window.onload = function() {
    setTimeout(function() {
    $.getJSON("https://wtfismyip.com/json", function(localizacao) {
        var cidade = localizacao['YourFuckingCity'].toLowerCase();
        var citiesElement = document.querySelector('.msg-free-shipping');
        var citiesString = citiesElement.dataset.cities;
        var cities = citiesString.split(',').map(city => city.trim());
        
        if (cities.includes(cidade)) {
            document.body.classList.add('has-free-shipping-city');
        } else {
            document.body.classList.remove('has-free-shipping-city');
        }

        // Dispara um evento customizado para notificar que a verificação foi concluída
        document.dispatchEvent(new CustomEvent('freeShippingChecked'));
    });
    }, 2000);
}